module.exports = __webpack_public_path__ + "static/media/viirtue-app-logo.fb40f685.png";